import {api} from './api';

interface ApiResponse<T> {
    code: string;
    success: boolean;
    message: string;
    data: T;
}

export interface Permission {
    permissionId?: number;
    permissionCode: string;
    permissionName: string;
    permissionType: 'RESOURCE' | 'FUNCTION';
    resourceType?: string;
    accessMode?: number;
    functionCode?: string;
    parentPermissionId?: number;
    permissionOrder?: number;
    description?: string;
    status?: string;
    isInitialized?: boolean;
    children?: Permission[];
}

export const permissionService = {
    /**
     * 获取权限树形结构
     */
    getPermissionTree: async (): Promise<Permission[]> => {
        const response = await api.get<ApiResponse<Permission[]>>('/api/v1/system/permissions/tree');
        return response.data.data || [];
    },

    /**
     * 获取所有权限列表
     */
    getAllPermissions: async (): Promise<Permission[]> => {
        const response = await api.get<ApiResponse<Permission[]>>('/api/v1/system/permissions');
        return response.data.data || [];
    },

    /**
     * 按类型获取权限
     */
    getPermissionsByType: async (type: 'RESOURCE' | 'FUNCTION'): Promise<Permission[]> => {
        const response = await api.get<ApiResponse<Permission[]>>(`/api/v1/system/permissions/type/${type}`);
        return response.data.data || [];
    },

    /**
     * 获取权限详情
     */
    getPermissionById: async (id: number): Promise<Permission> => {
        const response = await api.get<ApiResponse<Permission>>(`/api/v1/system/permissions/${id}`);
        return response.data.data!;
    },

    /**
     * 创建权限
     */
    createPermission: async (permission: Permission): Promise<Permission> => {
        const response = await api.post<ApiResponse<Permission>>('/api/v1/system/permissions', permission);
        return response.data.data!;
    },

    /**
     * 更新权限
     */
    updatePermission: async (id: number, permission: Partial<Permission>): Promise<Permission> => {
        const response = await api.put<ApiResponse<Permission>>(`/api/v1/system/permissions/${id}`, permission);
        return response.data.data!;
    },

    /**
     * 删除权限
     */
    deletePermission: async (id: number): Promise<void> => {
        const response = await api.delete(`/api/v1/system/permissions/${id}`);
        // 检查响应体中的业务 code（HTTP 200 但业务可能是失败）
        if (response.data?.code !== '0' || response.data?.success === false) {
            throw new Error(response.data?.message || '删除失败');
        }
    },
};